/* eslint-disable react/no-array-index-key */
import React, { FC, ReactNode } from 'react';
import { t } from '../../../../i18n';
import { CaseDescription } from '../CaseDescription';
import { CaseInfo } from '../CaseInfo';
import { ListSlider } from '../CaseSlider';
import styles from './styles.module.scss';

export type stack = {
  iconName?: string;
  caption?: string;
  text: string;
};

interface IProps {
  mobileList: stack[];
  backendList?: stack[];
  customList?: { caption: string; items: stack[] }[];
  androidList?: stack[];
  iosList?: stack[];
  renderCard: (el: stack) => ReactNode;
  infoText: ReactNode;
  title?: string;
  descriptionText?: string;
  descriptionParagraphs?: string[];
  styles?: { columnsCount?: 2 };
}

const CaseStack: FC<IProps> = ({
  mobileList,
  backendList,
  customList,
  androidList,
  iosList,
  renderCard,
  infoText,
  title,
  descriptionText,
  descriptionParagraphs,
  styles: caseStackStyles,
}) => (
  <div className={styles.stack}>
    <h2>{title || t('case.technology')}</h2>
    {descriptionParagraphs ? (
      <CaseDescription
        text={descriptionParagraphs.map((paragraph, i) => (
          <p key={i} dangerouslySetInnerHTML={{ __html: paragraph }} />
        ))}
      />
    ) : (
      descriptionText && <CaseDescription text={descriptionText} />
    )}

    {customList?.map((group) => (
      <>
        <p>
          <b>{group.caption}</b>
        </p>
        <ListSlider
          arr={group.items}
          renderCard={renderCard}
          columnsCount={caseStackStyles?.columnsCount}
        />
      </>
    ))}

    {backendList && <p>Backend</p>}
    {backendList && (
      <ListSlider
        arr={backendList}
        renderCard={renderCard}
        columnsCount={caseStackStyles?.columnsCount}
      />
    )}
    {backendList && <p>{t('case.mobile')}</p>}
    {androidList && (
      <p>
        <b>Android</b>
      </p>
    )}
    {androidList && (
      <ListSlider
        arr={androidList}
        renderCard={renderCard}
        columnsCount={caseStackStyles?.columnsCount}
      />
    )}
    <div />
    {iosList && (
      <p>
        <b>iOS</b>
      </p>
    )}
    {iosList && (
      <ListSlider
        arr={iosList}
        renderCard={renderCard}
        columnsCount={caseStackStyles?.columnsCount}
      />
    )}
    {mobileList && (
      <ListSlider
        arr={mobileList}
        renderCard={renderCard}
        columnsCount={caseStackStyles?.columnsCount}
      />
    )}
    {infoText && <CaseInfo text={infoText} />}
  </div>
);

export { CaseStack };
